export default "__VITE_ASSET__BvXmmLtR__"